module.exports = __webpack_public_path__ + "static/media/3.c621e6ac.jpg";